import React, { Component } from "react";
import { connect } from "react-redux";

import * as filtersActions from "../../redux/actions/filters";
import { getProfileFilters } from "../../../../SystemSettings/redux/actions/filters/filters";

import TopPanel from "../../components/Offers/TopPanel";
import Filters from "../../components/Offers/Filters";
import OffersTable from "../../components/Offers/OffersTable";
import ConfigTableCols from "../../components/Offers/ColConfigDrawer";

import PlacemarkMap from "../../../common/PlacemarkMap/PlacemarkMap";
import Footer from "../../../../../common/hoc/withFooter";
import moment from "moment";
import { Badge, Typography } from "antd";
import { getNumberWithoutSpaces } from "../../../../../common/utils/format";
import { getAllOffers } from "../../redux/actions/offers";
import { getSortObjectBySorter } from "../../../Executorship";
import { debounce } from "lodash";

const { Text } = Typography;
// Actions
const {
  updateFilterFieldsOffers,
  searchOffers,
  changeTypeListOffers,
  resetFiltersOffers
} = filtersActions;

class Offers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMap: false,
      isDrawerVisible: false,
      drawerCols: {
        info: true,
        view: true,
        state: true,
        passengers: true,
        price: true,
        actionDatetime: true,
        routeLength: false,
        dateApplication: true,
        placeDelivery: true,
        executor: false,
        settlementForm: false,
        driver: false,
        responsible: false,
        finalDestination: false,
        dateCreation: false,
        statusSendingACBDPL: false,
        sendingTrafficPolice: false
      },
      tableColumnsLen: 0,
      showFilterAll: false,
      filter: {
        status: false
      },
      pagination: {
        page: 1,
        limit: 5,
        total: null
      },
      offersType: null,
      changed: false,
      sortedColumn: null,
      visibleSuccessSaveFilter: false,
      visibleAcceptSaveFilter: false,
      offers: [],
      markers: []
    };
    this.fetchSearchStringDebounced = debounce(this.fetchSearchString, 1200);
    this.state.tableColumnsLen = this.getTableColumnsLen();
  }

  componentDidMount() {
    this.updateData();
    // if (!this.props.settingsFilters) {
    //   this.props.getProfileFilters();
    // }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.offers !== this.props.offers) {
      this.updateData();
    }
    if (this.state.changed !== prevState.changed) {
      // Отправляем запрос на каждое изменение стейта в заявках.
      this.fetchFilterRequest();
    }
  }

  updateData = () => {
    if (this.props.offers) {
      if (this.props.pagination) {
        this.setState({
          pagination: {
            ...this.state.pagination,
            total: this.props.pagination.total
          }
        });
      }
    }
  };

  // общая функция для отправки данных на сервер
  fetchFilterRequest = () => {
    this.props.getAllOffers({
      ...this.state.filter,
      type: this.state.offersType,
      page: this.state.pagination.page,
      limit: this.state.pagination.limit,
      searchField: this.state.searchField,
      sort: this.state.sortedColumn
    });
  };

  sortByColumn = e => {
    this.setState({
      ...this.state,
      sortedColumn: e,
      changed: !this.state.changed
    });
  };

  toggleAllFilter = () => {
    this.setState(() => ({
      showFilterAll: !this.state.showFilterAll
    }));
  };

  onChangeTypeList = e => {
    let statusRequest = e.target.value === "total" ? null : e.target.value;
    this.setState({
      offersType: statusRequest,
      changed: !this.state.changed,
      pagination: { ...this.state.pagination, page: 1 }
    });
  };

  onChangeSearch = e => {
    const { value } = e.target;
    this.setState({
      searchField: value
    });
    this.fetchSearchStringDebounced();
  };

  fetchSearchString = () => {
    this.fetchFilterRequest();
  };

  onPageChange = e => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        limit: e.pageSize,
        page: e.current
      },
      changed: !this.state.changed
    });
  };

  onPageSizeChange = e => {
    this.setState({
      pagination: { ...this.state.pagination, page: 1, limit: parseInt(e) },
      changed: !this.state.changed
    });
  };

  resetFilters = () => {
    this.props.resetFiltersOffers();
    this.props.getAllOffers();
  };

  toggleSaveCurrentFilter = () => {
    this.setState(() => ({
      visibleSuccessSaveFilter: !this.state.visibleSuccessSaveFilter
    }));
  };

  toggleAcceptCurrentFilter = () => {
    this.setState(() => ({
      visibleAcceptSaveFilter: !this.state.visibleAcceptSaveFilter
    }));
  };

  changePaginationSize = e => {
    this.setState(() => ({
      pagination: {
        pages: Number(e)
      }
    }));
  };

  toggleVisibleMap = () => {
    const visibleMap = this.state.visibleMap;

    this.setState(() => ({
      visibleMap: !visibleMap
    }));
  };

  // Todo сделать метки для карты
  filterMarkers = offers => {
    const markersList = [];

    offers &&
      offers.map(item =>
        markersList.push({
          article: item.info.article,
          dateApplication: item.dateApplication,
          address: `${item.placeDelivery.city} ${item.placeDelivery.address}`
        })
      );

    return markersList;
  };

  onChangeTable = (pagination, filters, sorter) => {
    const sort = getSortObjectBySorter(sorter);

    this.props.getAllOffers({ sort });
  };

  onColsChange = e => {
    const { drawerCols } = this.state;
    const newDrawerCols = {
      ...drawerCols,
      [e.target.name]: e.target.checked
    };
    const tableColumnsLen = this.getTableColumnsLen(newDrawerCols);
    this.setState({
      drawerCols: newDrawerCols,
      tableColumnsLen
    });
  };

  getTableColumnsLen = (drawerCols = null) => {
    return Object.values(
      drawerCols ? drawerCols : this.state.drawerCols
    ).reduce((count, val) => (val === true ? ++count : count), 0);
  };

  showDrawer = () => {
    this.setState({
      isDrawerVisible: true
    });
  };

  closeDrawer = () => {
    this.setState({
      isDrawerVisible: false
    });
  };

  getOffers() {
    const { offers } = this.props;
    const { filter } = this.state;
    if (!offers) return [];
    if (filter.status) {
      return offers.filter(
        item => item.state && item.state.statusKeyGroup === filter.status
      );
    }
    return offers;
  }

  renderColumns = () => {
    const { drawerCols: columns } = this.state;
    const filteredCols = [];
    let cols = [
      {
        title: "Номер предложения",
        title_full: "Номер предложения (Наименование)",
        dataIndex: "info",
        key: "info",
        render: info => {
          return (
            <span>
              <Text>
                {info.offerNumber && getNumberWithoutSpaces(info.offerNumber)}
              </Text>
              <br />
              {info.change && info.change !== info.create ? (
                <Text>Изменен: {moment(info.change).format("DD.MM.YYYY")}</Text>
              ) : info.create ? (
                <Text type="secondary">
                  Создан: {moment(info.create).format("DD.MM.YYYY")}
                </Text>
              ) : null}
            </span>
          );
        },
        sorter: true
      },
      {
        title: "Вид",
        title_full: "Вид транспортной услуги",
        dataIndex: "view",
        key: "view",
        render: view => (
          <span>
            <Text style={{ textTransform: "uppercase" }}>{view.abbr}</Text>
            <br />
            <Text style={{ color: view.color }}>{view.description}</Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Статус",
        title_full: "Статус заказа",
        dataIndex: "state",
        key: "state",
        render: state => (
          <span>
            <Text>
              {state.status === "Выполняется" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#00a8ff",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status === "Бронь" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#9b9b9b",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status === "Готов к выполнению" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#97dc76",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status === "Назначение" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#d9d9d9",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status}
            </Text>
            <br />
            <Text type="secondary" style={{ color: state.color }}>
              {state.description}
            </Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Пасс.",
        title_full: "Количество пассажиров",
        key: "passengers",
        render: row => (
          <span>{row.passengers < 1 ? "—" : row.passengers}</span>
        ),
        sorter: true
      },
      {
        title: "Цена",
        title_full: "",
        key: "price",
        render: row => {
          return (
            <Text>
              {row.totalPrice
                ? `${getNumberWithoutSpaces(row.totalPrice)} ₽`
                : "—"}
            </Text>
          );
        },
        sorter: true
      },
      {
        title: "Дата подачи",
        title_full: "",
        dataIndex: "dateApplication",
        key: "dateApplication",
        render: dateApplication =>
          dateApplication ? (
            <span>
              {moment(dateApplication).format("DD.MM.YYYY HH:mm")}
              <br />
              <Text type="secondary">{moment(dateApplication).fromNow()}</Text>
            </span>
          ) : null,
        sorter: true
      },
      {
        title: "Место подачи",
        title_full: "",
        dataIndex: "placeDelivery",
        key: "placeDelivery",
        render: placeDelivery => (
          <span style={{ whiteSpace: "normal" }}>
            <Text>{placeDelivery.address}</Text>
            <br />
            <Text type="secondary">{placeDelivery.city}</Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Форма расчетов",
        title_full: "",
        dataIndex: "settlementForm",
        key: "settlementForm",
        render: settlementForm => (
          <span>
            <Text>{settlementForm.description}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return (
            a.settlementForm.id && a.settlementForm.id - b.settlementForm.id
          );
        }
      },
      {
        title: "Водитель",
        title_full: "",
        dataIndex: "driver",
        key: "driver",
        render: driver =>
          driver && driver.length > 0
            ? driver.map(item => <div key={item.id}>{item.userName}</div>)
            : ""
      },
      {
        title: "Конечный пункт",
        title_full: "",
        dataIndex: "finalDestination",
        key: "finalDestination",
        render: finalDestination => (
          <span>
            <Text>{finalDestination.address}</Text>
            <br />
            <Text type="secondary">{finalDestination.city}</Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Дата создания",
        title_full: "",
        dataIndex: "info",
        key: "dateCreation",
        render: info =>
          info.create ? (
            <span>
              {moment(info.create).format("DD.MM.YYYY HH:mm")}
              <br />
              <Text type="secondary">{moment(info.create).fromNow()}</Text>
            </span>
          ) : null,
        sorter: true
      },
      {
        title: "Статус отправки в АЦБПДП",
        title_full: "",
        dataIndex: "statusSendingACBDP",
        key: "statusSendingACBDP"
      },
      {
        title: "Отправка в ГИБДД",
        title_full: "",
        dataIndex: "sendingTrafficPolice",
        key: "sendingTrafficPolice"
      }
    ];

    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }

    return filteredCols;
  };

  handleClickRow = row => {
    return {
      onClick: () => {
        this.props.history.push(`/executorship/offer/${row.id}`);
      }
    };
  };

  handleFiltersChange = values => {
    const val = Object.keys(values).reduce((acc, key) => {
      if (values[key]) {
        if (Array.isArray(values[key]) && values[key].length === 0) {
          return acc;
        }
        acc[key] = values[key];
      }
      return acc;
    }, {});
    this.props.updateFilterFieldsOffers(val);
  };

  render() {
    const {
      isDrawerVisible,
      drawerCols,
      filter,
      pagination,
      showFilterAll,
      markers,
      searchField
    } = this.state;

    const { offers } = this.props;

    return (
      <div className="offers">
        <ConfigTableCols
          columns={drawerCols}
          visible={isDrawerVisible}
          close={this.closeDrawer}
          changed={this.onColsChange}
        />
        <div className="offers__content">
          <TopPanel
            typesList={this.props.offerTypes}
            typesListValue={this.state.offersType}
            onChangeTypeList={this.onChangeTypeList}
            searchFieldValue={searchField}
            onChangeSearch={this.onChangeSearch}
          />
          <div className="offers__filters">
            <Filters
              showFilterAll={showFilterAll}
              filter={filter}
              showDrawer={this.showDrawer}
              toggleAllFilter={this.toggleAllFilter}
              handleFiltersChange={this.handleFiltersChange}
              visibleMap={this.state.visibleMap}
              toggleVisibleMap={this.toggleVisibleMap}
              settingsFilters={
                this.props.settingsFilters &&
                this.props.settingsFilters.off &&
                this.props.settingsFilters.off.keys
              }
              resetFilters={this.resetFilters}
            />
          </div>
          <div className="offers__map">
            {this.state.visibleMap && <PlacemarkMap markers={markers} />}
          </div>
          <OffersTable
            renderColumns={this.renderColumns}
            tableColumnsLen={this.state.tableColumnsLen}
            offers={offers}
            offersLoading={this.props.offersLoading}
            handleClickRow={this.handleClickRow}
            onChangeRowSelection={this.onChangeRowSelection}
            pagination={pagination}
            sortByColumn={this.sortByColumn}
            onPageSizeChange={this.onPageSizeChange}
            onPageChange={this.onPageChange}
          />
        </div>
        <Footer>{/*<OffersFooter />*/}</Footer>
      </div>
    );
  }
}

export default connect(
  state => {
    const { offers, filters } = state.Executorship.Offers;
    const { profileFilters } = state.SystemSettings.filters;
    return {
      offersLoading: offers.offersLoading,
      // offers: filters.count > 0 ? offers.filterOffers : offers.allOffers,
      offers: offers.allOffers && offers.allOffers,
      pagination: offers.allOffers && offers.pagination,
      offersStat:
        filters.count > 0 ? offers.filterOffersStat : offers.allOffersStat,
      offerTypes: offers.offerTypes,
      filters,
      settingsFilters: profileFilters
    };
  },
  {
    getAllOffers,
    //  Filters
    updateFilterFieldsOffers,
    searchOffers,
    resetFiltersOffers,
    changeTypeListOffers,
    getProfileFilters
  }
)(Offers);
